// extracted by css-extract-rspack-plugin
export default {"withoutTransitions":"TSPYr"};